import Common from '@vendor/js/common';
const _FormComponentHandler = (function () {
    // Alert before leave with unsaved changes.
    // Timeout, so it does not catch automated triggers
    let unsubmittedForms = [];
    const inputs = $(':input');
    const body = $('body');
    const releaseUnsubmittedForm = (id) => {
        unsubmittedForms = unsubmittedForms.filter((i) => i !== id);
    };
    return {
        // Public functions
        init: function () {
            setTimeout(() => {
                body.on('change', ':input', function () {
                    if ($(this).attr('type') === 'search') {
                        return;
                    }
                    let form = $(this).closest('form');
                    let id = form.attr('id');
                    if (form.data('app-prevent_exit') === false) {
                        return;
                    }
                    if (typeof id == 'undefined' ||
                        !id ||
                        unsubmittedForms.includes(id)) {
                        return;
                    }
                    unsubmittedForms = [...unsubmittedForms, id];
                });
                // Remove errors from inputs that has been changed
                body.on('change', ':input', function () {
                    if ($(this).hasClass('is-invalid')) {
                        Common.clearFormInputError($(this).closest('form'), $(this).attr('name'));
                    }
                });
            }, 2000);
            $('form').on('submit', function () {
                const id = $(this).attr('id');
                if (typeof id == 'undefined') {
                    return null;
                }
                releaseUnsubmittedForm(id);
            });
            window.onbeforeunload = function () {
                if (unsubmittedForms.length > 0) {
                    return 'Posiadasz niezapisane zmiany. Czy jesteś pewny/a, że chcesz wyjść?';
                }
            };
        },
        releaseUnsubmittedForm,
    };
})();
window.FormComponentHandler = _FormComponentHandler;
